import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useSEO from '@/hooks/useSEO';

export default function NotFound() {
  useSEO({
    title: '页面未找到',
    description: '抱歉，您访问的页面不存在。请返回亚洲在线首页继续浏览。',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main className="min-h-[70vh] flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-24 h-24 mx-auto flex items-center justify-center rounded-3xl bg-background-100 text-foreground-400 mb-6">
            <i className="ri-error-warning-line text-4xl"></i>
          </div>
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-foreground-950 mb-3">404</h1>
          <p className="text-lg text-foreground-600 mb-2">抱歉，页面未找到</p>
          <p className="text-sm text-foreground-500 mb-8">您访问的页面可能已被移除或链接地址有误</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              返回首页
            </Link>
            <Link
              to="/category/news"
              className="px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览资讯
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}